import ApiService from '../services/ApiService';
import * as types from './ActionTypes';
import {
  goToErrorPage, goToNextStep, setInputError,
} from './GenericActions';
import * as probes from './probes_action';
import TagService from '../services/TagService';

const sendingOtp = ({ contactId }) => ({
  type: types.CREATE_OTP,
  payload: {
    contactId,
  },
  requestAt: Date.now(),
});

const createOtpSuccess = resourceId => ({
  type: types.CREATE_OTP_SUCCESS,
  payload: {
    otc: resourceId,
  },
  receivedAt: Date.now(),
});

const retryOtcSuccess = resourceId => ({
  type: types.RETRY_OTC_SUCCESS,
  payload: {
    otc: resourceId,
  },
  receivedAt: Date.now(),
});

const createOtpFailure = error => ({
  type: types.CREATE_OTP_FAILURE,
  error,
  receivedAt: Date.now(),
});

const checkingOtp = ({ otpsId, otpCode }) => ({
  type: types.CHECKING_OTP,
  payload: {
    otpsId,
    otpCode,
  },
  requestAt: Date.now(),
});

const checkOtpSuccess = () => ({
  type: types.CHECK_OTP_SUCCESS,
  receivedAt: Date.now(),
});

const checkOtpFailure = error => ({
  type: types.CHECK_OTP_FAILURE,
  error,
  receivedAt: Date.now(),
});

const otpIsBlacklisted = () => ({
  type: types.OTP_IS_BLACKLISTED,
  receivedAt: Date.now(),
});

/**
 * Function to create or retry a One Time Code by calling partners api
 * @param contact
 * @param useCase
 */
export const sendOtp = ({ contact, isRetry = false }) => ((dispatch) => {
  const { contactId, contactType } = contact;

  const otcMethod = isRetry ? ApiService.retryOtp({ contactId }) : ApiService.createOtp({ contactId });

  if (isRetry) {
    TagService.sendAction('retryCode');
  }

  dispatch(probes.recordingProbeStarted());
  dispatch(sendingOtp(contact));

  return otcMethod.then(
    (res) => {
      const { step, data } = res.data;
      if (isRetry) {
        dispatch(retryOtcSuccess(data.resourceId));
      } else {
        dispatch(createOtpSuccess(data.resourceId));
      }
      dispatch(goToNextStep(step));
    },
    (err) => {
      dispatch(createOtpFailure(err));
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 403:
            dispatch(otpIsBlacklisted());
            if (contactType.toLowerCase() === 'm') {
              dispatch(goToErrorPage('otcSmsIsBlacklisted'));
            } else {
              dispatch(goToErrorPage('otcMailIsBlacklisted'));
            }
            break;
          default:
            dispatch(goToErrorPage());
            break;
        }
      }
    },
  );
});

/**
 * Function to check the One Time Code input with the one sent by partners api
 * Go to the next step when the OTC corresponding
 * @param otpCode
 * @returns {const}
 */
export const checkOtp = ({ otpCode }) => (dispatch, getState) => {
  const otpsId = getState().otp.otc.value;

  dispatch(probes.recordingProbeStarted());
  TagService.sendAction('checkCode');

  dispatch(checkingOtp({ otpsId, otpCode }));
  return ApiService.checkOtpCode({ otpsId, otpCode }).then(
    (res) => {
      const { step } = res.data;
      dispatch(checkOtpSuccess());
      dispatch(goToNextStep(step));
    },
    (err) => {
      dispatch(checkOtpFailure(err.response));
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 403:
            dispatch(otpIsBlacklisted());
            dispatch(goToErrorPage('otcAttemptsExceeded')); // Blacklisted, attempts exceeded
            break;
          case 412: {
            const { code } = err.response.data;
            switch (code) {
              case 412002:
                dispatch(setInputError({
                  field: 'otc',
                  error: 'empty',
                })); // Empty code
                break;
              case 412004:
                dispatch(setInputError({
                  field: 'otc',
                  error: 'nan',
                })); // Code syntaxically invalid
                break;
              case 412005:
                dispatch(setInputError({
                  field: 'otc',
                  error: 'incorrect',
                })); // Incorrect code
                break;
              case 412301:
                dispatch(goToErrorPage('otcIsExpired')); // Expired code message
                break;
              default:
                dispatch(goToErrorPage());
                break;
            }
            break;
          }
          default:
            dispatch(goToErrorPage());
            break;
        }
      }
    },
  );
};
